import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexCreative',
  setup(__props) {

const BorderCard = defineAsyncComponent(() => import("@/components/theme/advance/creative/BorderCard.vue"))
const PrimaryState = defineAsyncComponent(() => import("@/components/theme/advance/creative/PrimaryState.vue"))
const WarningState = defineAsyncComponent(() => import("@/components/theme/advance/creative/WarningState.vue"))
const SecondaryState = defineAsyncComponent(() => import("@/components/theme/advance/creative/SecondaryState.vue"))
const AbsoluteCard = defineAsyncComponent(() => import("@/components/theme/advance/creative/AbsoluteCard.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Bonus Ui",
      mains: "Creative Card",
      title: "Creative Card"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(BorderCard)),
        _createVNode(_unref(PrimaryState)),
        _createVNode(_unref(WarningState)),
        _createVNode(_unref(SecondaryState)),
        _createVNode(_unref(AbsoluteCard))
      ])
    ])
  ], 64))
}
}

})